import { BaseService } from '../../../../../core/services/base.service';
import { InvitedUser, UserId, User } from '../models/users.model';

export class UsersService {
  static async GetUsers(
    companyId: string,
    params?: {
      page?: number;
      size?: number;
      sort?: string;
      filter?: string;
    }
  ): Promise<{ content: UserId[]; totalElements: number }> {
    const query = params
      ? `?${new URLSearchParams(params as Record<string, string>).toString()}`
      : '';

    return await BaseService.Get(`/companies/${companyId}/users${query}`);
  }

  static async GetInvitedUsers(companyId: string): Promise<InvitedUser[]> {
    return await BaseService.Get(`/companies/${companyId}/user-registrations`);
  }

  static async GetById(companyId: string, userId: string): Promise<UserId> {
    return await BaseService.Get(`/companies/${companyId}/users/${userId}`);
  }

  static async GetFile(userId: string, fileId: string): Promise<Blob> {
    return await BaseService.Blob(
      'GET',
      `/users/${userId}/files/{fileId}?fileId=${fileId}`,
      undefined,
      undefined,
      false
    );
  }

  static async Post(companyId: string, user: User): Promise<User> {
    try {
      const payload = {
        firstname: user.firstname,
        lastname: user.lastname,
        email: user.email,
        admin: user.admin,
        id: companyId,
      };
      const response = await BaseService.Post(
        '/public/user-registrations',
        payload
      );
      return response;
    } catch (error) {
      console.error(
        'API Error:',
        error instanceof Error ? error.message : 'Unknown error'
      );
      throw error;
    }
  }

  static async Delete(companyId: string, userId: string): Promise<UserId[]> {
    return await BaseService.Delete(`/companies/${companyId}/users/${userId}`);
  }

  static async Put(
    companyId: string,
    userId: string,
    user: any
  ): Promise<UserId> {
    try {
      const payload = {
        firstname: user.firstname,
        lastname: user.lastname,
        email: user.email,
        phoneNumber: user.phoneNumber,
        active: user.active,
        roles: user.roles || [],
        whatsappNotifiable: user.whatsappNotifiable,
        emailNotifiable: user.emailNotifiable,
      };
      const response = await BaseService.Put(
        `/companies/${companyId}/users/${userId}`,
        payload
      );
      return response;
    } catch (error: any) {
      console.error('UsersService.Put - Error response:', error.response);
      throw error;
    }
  }
}
